import { Icon, Tooltip } from "../externals";
import * as React from "react";
import "./Error.scss";
export function Error({ message, minimal = false, size = 100, }) {
    return minimal ? (React.createElement(Tooltip, { content: message },
        React.createElement("div", { className: "error-component" },
            React.createElement(Icon, { icon: "error", size: size }),
            React.createElement("div", { className: "error-component_heading" }, "Error")))) : (React.createElement("div", { className: "error-component", style: { flexDirection: "column" } },
        React.createElement(Icon, { icon: "error", size: size }),
        React.createElement("div", { className: "error-component_heading" }, "Error"),
        React.createElement("div", { className: "error-component_message" }, message)));
}
//# sourceMappingURL=index.js.map